import { SegmentedControl } from '@/components/UI';
import type { SearchSelectItem } from '@/components/UI/SearchSelect';
import { PERFORMANCE_PERIODS, type PerformanceBasis, type PerformancePeriodKey } from '../performanceUtils';
import StrategyScopeSelect from './StrategyScopeSelect';

interface PerformanceControlsProps {
    period: PerformancePeriodKey;
    onPeriodChange: (period: PerformancePeriodKey) => void;
    basis: PerformanceBasis;
    onBasisChange: (basis: PerformanceBasis) => void;
    /** Hidden when the portfolio never had an external deposit or withdrawal, since both bases are identical. */
    showBasisToggle: boolean;
    scopeItems: SearchSelectItem[];
    selectedStrategyIds: number[];
    onStrategyIdsChange: (strategyIds: number[]) => void;
}

const PerformanceControls = ({
    period,
    onPeriodChange,
    basis,
    onBasisChange,
    showBasisToggle,
    scopeItems,
    selectedStrategyIds,
    onStrategyIdsChange
}: PerformanceControlsProps) => (
    <div className="flex flex-col gap-3">
        <div className="flex flex-wrap items-center gap-3">
            <SegmentedControl
                ariaLabel="Period"
                options={PERFORMANCE_PERIODS.map((entry) => ({ value: entry.key, label: entry.label, title: entry.description }))}
                value={period}
                onChange={onPeriodChange}
            />
            {showBasisToggle && (
                <SegmentedControl
                    ariaLabel="P&L basis"
                    options={[
                        { value: 'trading', label: 'Trading P&L', title: 'Deposits and withdrawals removed' },
                        { value: 'funding', label: 'Incl. funding', title: 'Raw equity change' }
                    ]}
                    value={basis}
                    onChange={onBasisChange}
                />
            )}
        </div>

        {scopeItems.length > 0 && (
            <div className="max-w-4xl">
                <StrategyScopeSelect items={scopeItems} value={selectedStrategyIds} onChange={onStrategyIdsChange} />
            </div>
        )}
    </div>
);

export default PerformanceControls;
